export var DeliveryScheduleRemappingText;
(function (DeliveryScheduleRemappingText) {
    DeliveryScheduleRemappingText["REMAPPING_BLOCKING_COPY"] = "We apologize for any inconvenience, but this update requires changes to at least one of your orders or subscriptions. Kindly get in touch with us so that we can assist you in making these adjustments.";
    DeliveryScheduleRemappingText["CANCEL"] = "Cancel";
    DeliveryScheduleRemappingText["DELIVERY"] = "Delivery";
    DeliveryScheduleRemappingText["KEEP_ORIGINAL"] = "Keep Original";
    DeliveryScheduleRemappingText["MEAL_SUMMARY"] = "Meal summary";
    DeliveryScheduleRemappingText["ORDER_NUMBER"] = "Order Number:";
    DeliveryScheduleRemappingText["ORDER_NUMBER_NOT_FOUND"] = "Order number not found!";
    DeliveryScheduleRemappingText["SHIP_DATE"] = "Ship date";
    DeliveryScheduleRemappingText["DEFAULT_TEXT_COPY"] = "Rescheduling will affect the days currently on the order, and the days on the renewed order once renewed.";
    DeliveryScheduleRemappingText["DEFAULT_TITLE_COPY"] = "Order Update";
    DeliveryScheduleRemappingText["UPDATE_ORDER"] = "Update Order";
    DeliveryScheduleRemappingText["UPDATE_SUBSCRIPTION"] = "Update Subscription";
    DeliveryScheduleRemappingText["UPDATE_PRIMARY_ADDRESS"] = "Update Primary Address";
})(DeliveryScheduleRemappingText || (DeliveryScheduleRemappingText = {}));
var NumbersText;
(function (NumbersText) {
    NumbersText["RESCHED"] = "Rescheduling order";
    NumbersText["OF"] = "of";
})(NumbersText || (NumbersText = {}));
export const reschedulingText = (currentOrderNumber, totalNumberOfOrders) => `${NumbersText.RESCHED} ${currentOrderNumber} ${NumbersText.OF} ${totalNumberOfOrders}.`;
export var DeliveryAddressStatus;
(function (DeliveryAddressStatus) {
    DeliveryAddressStatus["ORIGINAL"] = "Original";
    DeliveryAddressStatus["UPDATED"] = "Updated";
})(DeliveryAddressStatus || (DeliveryAddressStatus = {}));
